import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-lg mt-3 text-gray-600">
        Page Not Found
      </p>
      <Link
        to="/"
        className="mt-6 bg-black text-white px-6 py-3 rounded"
      >
        Go Home
      </Link>
    </div>
  );
}
